import styled from 'styled-components';
import {
  desktop_breakpoint,
  desktop_breakpoint_extended,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

const PostsDeckStyles = styled.div`
  margin: 0 auto;
  width: 88%;

  .main-heading {
    margin-bottom: 40px;
    padding: 5px 0 0 0;
    .h4 {
      font-weight: 500;
    }
  }
  .post-card-container {
    cursor: pointer;
    margin-bottom: 20px;

    a {
      text-decoration: none;
    }
    .post-card-info {
      .heading-component {
        max-width: 92%;
      }
    }
    img {
      height: 100%;
    }
  }

  .load-more {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 64px;
    padding-top: 20px;

    .compact {
      font-size: 14px;
      height: 51px;
      align-content: center;
    }
  }

  @media screen and (min-width: ${desktop_breakpoint}px) {
    margin: 0 auto;
    max-width: 475px;
  }

  @media screen and (min-width: ${desktop_breakpoint_extended}px) {
    max-width: 1160px;
    width: 100%;

    .post-cards {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      padding-bottom: 20px;

      .post-card-container {
        box-sizing: border-box;
        margin: 0;
        margin-bottom: 20px;
        width: 23%;
        margin-right: 20px;

        &:last-child {
          margin-right: 0;
        }
      }
      .large-card-format {
        display: flex;
        justify-content: space-evenly;
        width: 100%;

        .first-card {
          width: 50%;

          .post-card-container {
            margin-right: 0;

            > div {
              height: 672px;
            }

            margin-bottom: 0;
            max-width: 562px;
            width: 100%;
          }
        }
        .remaining-cards {
          flex-wrap: wrap;
          display: flex;
          justify-content: space-between;
          width: 48%;

          .post-card-container {
            margin-bottom: 0;
            max-width: 290px;
            width: 48%;
            margin-right: 0;

            &:nth-child(-n + 2) {
              margin-bottom: 20px;
            }
          }
        }
      }
    }
  }
`;

export default PostsDeckStyles;
